///////////////////////////////////////////////////

import {
  isNavigatingInSecondaryMarketPostEventsWorkspace,
  isNavigatingInSecondaryOrderBlotter,
} from 'epic/utils/navigation/navigation';
import { filter, map, take } from 'rxjs/operators';
import type { EpicWithThunk } from 'state/state.common';
import { workspaceTabsFetchRequested } from 'state/workspaces/workspace.actions';

export function enterWorkspaceEpic(): EpicWithThunk {
  return (actions$, _state$, { getNewGuid }) => {
    return actions$.pipe(
      filter(
        action =>
          isNavigatingInSecondaryMarketPostEventsWorkspace(action) || isNavigatingInSecondaryOrderBlotter(action),
      ),
      take(1),
      map(() => {
        const fetchId = getNewGuid();
        return workspaceTabsFetchRequested('secondaryMarketPostEvents', fetchId);
      }),
    );
  };
}
